import { render } from "./NotificationsModal.vue?vue&type=template&id=410e60a6&ts=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=ts"
export * from "./NotificationsModal.vue?vue&type=script&lang=ts"

import "./NotificationsModal.vue?vue&type=style&index=0&id=410e60a6&lang=css"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__